var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"runtime-graph"},[_c('highcharts',{staticClass:"runtime-chart",attrs:{"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }